import dayjs from "dayjs";

export function formatDate(date, format = "DD-MM-YYYY, HH:MMa") {
    return dayjs(date).format(format);
}